/* unplugin-vue-components disabled */import script from "./Tag.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tag.vue?vue&type=script&lang=ts&setup=true"

import "./Tag.vue?vue&type=style&index=0&id=08fa169f&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fa169f"]])

export default __exports__